<div class="db-plugins">

  <div class="db-website-connected-first-time-use-overlay" *ngIf="websiteConnected">
    <div class="db-website-connected-first-time-use-wrap">
      <div class="db-website-connected-first-time-use-desc">
        <h4>Get your premium plugin</h4>
        <p>Please click the button above to install and start using the purchased premium plugin.</p>
      </div>
      <div class="db-website-connected-first-time-use-button"><a class="db-button db-button_info" (click)="onAvailablePlugins()"><span>{{'text_addNewPlugins' | dbText}}</span></a></div>
    </div>
  </div>
  <db-ai-builder-demo-banner *ngIf="demoUser" [title]="'Plugins'" [features]="features" [class]="'with_margins'">
  </db-ai-builder-demo-banner>

  <ds-mobile-page-title></ds-mobile-page-title>

  <div class="db-buttons__addPlugins" *ngIf="plugins && plugins.length">
    <a class="ds-btn-m ds-btn-blue ds-z-index" [ngClass]="{'ds-pointer-events-none': demoUser}" (click)="onAvailablePlugins()"><span>{{'text_addNewPlugins' | dbText}}</span></a>
  </div>
  <div class="db-buttons__addPlugins-tabs" [ngClass]="{'disabled-with-overlay': demoUser}">
    <ds-tabs [activeTabId]="filterBy.value" (onActiveTabChange)="onPluginStateChange($event)" class="db-plugins__tabs"
             [ngClass]="{'db-page-with-banner': hasHostingBanner}">
      <ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="all" [activeTabId]="filterBy.value">
        <span class="sl-all-plugins">{{'text_all-plugins' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="active" [activeTabId]="filterBy.value">
        <span class="sl-active-plugins">{{'text_active-plugins' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="inactive" [activeTabId]="filterBy.value">
        <span class="sl-inactive-plugins">{{'text_inactive-plugins' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="updateAvailable" [activeTabId]="filterBy.value">
        <span class="sl-update-available-plugins">{{'text_update-available' | dbText}}</span>
      </ds-tab-head>
      <!--<ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="scheduling" [activeTabId]="filterBy.value">
        <span class="sl-scheduling-plugins">{{'text_scheduling' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-head [withBorder]="true" *ngIf="plugins && plugins.length" tabId="schedulingHistory" [activeTabId]="filterBy.value">
        <span class="sl-scheduling-history-plugins">{{'text_plugins-scheduling-history' | dbText}}</span>
      </ds-tab-head>-->

      <ds-tab-content class="db-plugins__tab-content" *ngIf="['all','active','inactive','updateAvailable'].includes(filterBy.value)">

        <div class="db-plugins__content-wrapper" *ngIf="itemsView.value === 'list'">

          <div class="db-plugins__content db-plugins__content_list_view">
            <div class="db-plugins__items">
              <div class="db-plugins__filters db-filters-bar" *ngIf="!hideFilterBar">
                <div>
                  <label class="db-plugins__select-all-toggle" *ngIf="userPermissions?.canManageContent && !website?.isLocalhost">
                    <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                    <span>{{'text_managerPlugins' | dbText}}</span>
                  </label>
                </div>
                <div [ngClass]="{'db-go-right': website?.isLocalhost}" >
                  <label class="db-plugins__select-all-toggle" *ngIf="userPermissions?.canManageContent && itemsView.value === 'list' && !website?.isLocalhost">
                    <span *ngIf="filterBy.value !== 'updateAvailable'">{{'text_currentVersion' | dbText}} </span>
                    <span *ngIf="filterBy.value === 'updateAvailable'">{{'text_version' | dbText}} </span>
                  </label>
                  <div class="search-wrap" >
                    <db-fc-search-input [formControl]="searchTerm" [placeholderTitle]="'text_searchPluginsPlaceholder' | dbText"  placeholder="SEARCH..."></db-fc-search-input>
                  </div>
                </div>
              </div>
              <div class="db-product-items-wrap" *ngIf="filteredPlugins && filteredPlugins.length" dbCustomScrollbar>
                <db-product-item (toggled)="onItemToggled()" [@productItemAnimation]="!updatingProductsList" class="db-product-item-host_view_{{itemsView.value}} db-product-item__{{i}}" [allProducts]="plugins" [website]="website" [product]="plugin" [scope]="pluginsScope" [userPermissions]="userPermissions" *ngFor="let plugin of filteredPlugins; trackBy: productTrackBy; let i = index" [ngClass]="[filterBy.value == 'updateAvailable' ? 'updateAvailable' : '' , (filteredPlugins.length-1 == i ? 'lastChild' : '')]" [activeTab]="filterBy.value"></db-product-item>
              </div>

              <div class="db-no-plugins-message" *ngIf="plugins && plugins.length && filteredPlugins && !filteredPlugins.length && searchTerm.value === ''">
                <div class="db-no-plugins-image-wrap db-no-plugins-image-wrap-empty">
                  <img class="db-empty-search" src="assets/images/icons/plugins-empty.svg" alt=""/>
                </div>
                <div class="db-no-plugins-text-wrap">
                  <span [innerHtml]="filterBy.value === 'active' ? ('text_noActivePlugins' | dbText ) : filterBy.value === 'inactive' ? ('text_noInActivePlugins' | dbText) : filterBy.value === 'updateAvailable' ? ('text_noUpgradablePlugins' | dbText) : ''"></span>
                </div>
              </div>
              <div class="db-no-plugins-message" *ngIf="plugins && !plugins.length">
                <div class="db-no-plugins-image-wrap">
                  <img class="db-empty-search" src="assets/images/icons/plugins_white_bg.svg" alt=""/>
                </div>
                <div class="db-no-plugins-text-wrap">
                  <div class="db-no-plugins-text-title-wrap">
                    <span>{{'text_emptyPageTitle' | dbText}}</span>
                  </div>
                  <span class="no-plugins" [innerHtml]="('text_noPlugins' | dbText)"></span>
                </div>
                <div class="db-buttons__addPlugins db-add-plugins-header">
                  <a class="db-button db-button_info" (click)="onAvailablePlugins()"><span>{{'text_addNewPlugins' | dbText}}</span></a>
                </div>
              </div>

              <db-empty-search (onClickAction)="onAvailablePlugins()"  [textTitle]="'text_pluginsEmptyTitle' | dbText" [page]="'plugins'" *ngIf="plugins && plugins.length && filteredPlugins && !filteredPlugins.length && searchTerm.value != ''"></db-empty-search>
            </div>

          </div>
          <span *ngIf="userPermissions?.canManageContent && itemsView.value === 'list' && filteredPlugins && filteredPlugins.length" class="db-plugins__actions">
            <a class=" ds-btn ds-btn-s ds-btn-green" (click)="applyBulkAction(ActivityAction.ACTIVATE, false)" *ngIf="filterBy.value === 'inactive' || filterBy.value === 'all'" [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedPlugins.length}"><span>{{'text_activate' | dbText | lowerCaseSpecificWords}}</span></a>
            <a class="ds-btn ds-btn-s" (click)="applyBulkAction(ActivityAction.DEACTIVATE, false)" *ngIf="filterBy.value === 'active' || filterBy.value === 'all'" [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedPlugins.length}"><span>{{'text_deactivate' | dbText | lowerCaseSpecificWords}}</span></a>
            <a class="ds-btn ds-btn-s ds-btn-red" (click)="applyBulkAction(ActivityAction.DEACTIVATE_DELETE, true)" *ngIf="filterBy.value === 'active'" [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedPlugins.length}"><span>{{'text_deactivateDelete' | dbText | lowerCaseSpecificWords}}</span></a>
            <a class="ds-btn ds-btn-s"  (click)="applyBulkAction(ActivityAction.UPDATE, false)"  *ngIf="filterBy.value === 'updateAvailable' || filterBy.value === 'all'" [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedPlugins.length}"><span>{{'text_update' | dbText | lowerCaseSpecificWords}}</span></a>
            <a class="ds-btn ds-btn-s ds-btn-red" (click)="applyBulkAction(ActivityAction.DEACTIVATE_DELETE, true)" *ngIf="filterBy.value === 'inactive' || filterBy.value === 'all'" [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedPlugins.length}"><span>{{'text_delete' | dbText | lowerCaseSpecificWords}}</span></a>
            <span *ngIf="!!selectedPlugins.length && filterBy.value === 'updateAvailable'">{{'text_selectedPluginsCount' | dbText : {selectedPluginsCount: selectedPlugins.length} }}</span>
        </span>
        </div>
      </ds-tab-content>

      <ds-tab-content *ngIf="filterBy.value === 'scheduling'">
        <div class="db-plugins__schedule-tab" dbCustomScrollbar>
          <div class="db-scheduling-enable-block">
            <div class="db-switch-title">{{ 'text_enableScheduling' | dbText }}</div>
            <label class="db-fc-switch sl-enable-scheduling-switch">
              <input class="db-switch__input" type="checkbox" [checked]="scheduleEnabled" (change)="enableScheduling($event)">
              <span class="db-switch__bg">
                        <span class="db-switch__head"></span>
                      </span>
            </label>
          </div>
          <div class="db-scheduling-wrap" [ngClass]="{'db-disabled': !scheduleEnabled}">
            <div class="db-schedule-main-content">
              <db-schedule *ngIf="scheduleCronExpression" (cronExpressionString)="generateScheduleData($event)" [cron_expression]="scheduleCronExpression" [title]="'text_pluginScheduleTitle' | dbText"></db-schedule>
            </div>
           <!-- <div class="db-schedule-backup-block" *ngIf="!(currentSubscription?.plan?.planPrice === 0 && !website?.domain_hash)">
              <div class="db-schedule-backup-block-text">
                <div class="db-schedule-backup-block-text-title">{{'text_pluginsBackupSchedulingTitle' | dbText}}</div>
                <div class="db-schedule-backup-block-text-desc">{{'text_pluginsBackupSchedulingDesc' | dbText}}</div>
              </div>
             &lt;!&ndash; <div class="db-schedule-backup-block-actions">
                <div class="db-schedule-backup-block-actions-enable" *ngIf="!backupPlugin.active">
                  <a [routerLink]="['../../backup']" >Enable backup service</a><span> to perform safe update</span>
                </div>
                <div class="db-schedule-backup-block-actions-enabled" *ngIf="backupPlugin.active">
                  <label class="db-fc-switch sl-enable-scheduling-switch">
                    <input class="db-switch__input" type="checkbox" [checked]="scheduleWithBackupEnabled" (change)="enableSchedulingWithBackup($event)">
                    <span class="db-switch__bg">
                        <span class="db-switch__head"></span>
                      </span>
                  </label>
                </div>
              </div>&ndash;&gt;
            </div>-->
            <div class="db-schedule-include-exclude-block">
              <div class="db-schedule-include-exclude-title">{{'text_pluginsScheduleIncludeExcludeTitle' | dbText}}</div>
              <div class="items-wrap db-panel_flex">
                <div>
                  <db-product-item-schedule (toggled)="onItemToggledForSchedule()" *ngFor="let product of pluginsForSchedule; trackBy: productTrackBy; let i = index;" class="db-product-item-host_view_list db-product-item__{{i}}" (actionDone)="reloadContent()" [website]="website" [product]="product" ></db-product-item-schedule>
                </div>
                <div class="db-panel__footer">
                  <label>
                  <span class="db-fc-checkbox" [ngClass]="{
    'selected': selectAllForSchedule.value}"><input type="checkbox" [formControl]="selectAllForSchedule" (change)="toggleAllItemsSelectedForSchedule($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                    <span class="db-products__actions-label">{{'text_includeAll' | dbText}}</span>
                  </label>

                  <div>
                    <span *ngIf="selectedPluginsForSchedule.length" class="db-products__actions-label">{{'selectedProductsForSchedule' | dbText : {selectedProductsCount: selectedPluginsForSchedule.length} }}</span>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div class="button-wrap">
            <a class="ds-btn ds-btn-m db-button_success" (click)="onScheduleSubmit()" [ngClass]="{'db-button_disabled': pluginsScheduleLoading}">
              <span *ngIf="!pluginsScheduleLoading">{{ 'text_saveSchedule' | dbText }}</span>
              <db-loading-circular-spinner class="sl-save-scheduling-params-progress" *ngIf="pluginsScheduleLoading"></db-loading-circular-spinner>
            </a>
          </div>

        </div>
        <db-loading-screen [ngClass]="{'hidden': !pluginListUpdateLoading}" [pageBlocker]="true"  [loadingMessage]="'Your plugins list are updating'"></db-loading-screen>

      </ds-tab-content>

      <ds-tab-content *ngIf="filterBy.value === 'schedulingHistory'">
        <div class="db-panel db-panel_flex db-plugin-schedule-update-history-wrap">
          <div class="db-panel__header db-plugin-schedule-update-history-header"  *ngIf="pluginUpdateHistory && pluginUpdateHistory.length">
            <div class="db-header-wrap db-plugin-schedule-update-history-header-wrap">
              <div class="db-plugin-schedule-update-history-list-title">
                <span>{{'text_updateHistoryDate' | dbText}}</span>
                <a class="db-table-sorting-indicator" *ngIf="pluginUpdateHistory.length > 1" (click)="sortTable('date')" [ngClass]="getSortDirectionClass('date')"><i class="db-icon db-icon-arrow-down"></i></a>
              </div>
              <div class="db-plugin-schedule-update-history-list-title">
                <span>{{'text_updateHistoryName' | dbText}}</span>
                <a class="ds-table-sorting-indicator" *ngIf="pluginUpdateHistory.length > 1" (click)="sortTable('name')" [ngClass]="getSortDirectionClass('name')"><i class="db-icon db-icon-arrow-down"></i></a>
              </div>
              <div class="db-plugin-schedule-update-history-list-title">
                <span>{{'text_updateHistoryUpdatedVersion' | dbText}}</span>
              </div>
            </div>
          </div>
          <div class="db-panel__body db-plugin-update-history-block-body"  *ngIf="pluginUpdateHistory && pluginUpdateHistory.length" dbCustomScrollbar>
            <div class="db-plugin-schedule-update-item" *ngFor="let updateItem of pluginUpdateHistory">
              <div class="db-plugin-schedule-update-item__date">{{updateItem.date | dbDate : 'dd MMM y, HH:mm:ss'}}</div>
              <div class="db-plugin-schedule-update-item__name">{{updateItem.name}}</div>
              <div class="db-plugin-schedule-update-item__updatedVersion">{{updateItem.oldVersion}}<span> > </span>{{updateItem.newVersion}}</div>
            </div>
          </div>
          <div class="db-plugin-schedule-update-history-empty" *ngIf="!pluginUpdateHistory || (pluginUpdateHistory && !pluginUpdateHistory.length)">
            <div class="db-plugin-schedule-update-history-empty-title">{{'text_scheduleProductUpdateHistoryEmptyTitle' | dbText}}</div>
            <div class="db-plugin-schedule-update-history-empty-desc">{{'text_scheduleProductUpdateHistoryEmptyDesc' | dbText}}</div>
          </div>
        </div>

      </ds-tab-content>

    </ds-tabs>
    <db-how-to-videos [url]="'https://www.youtube.com/embed/Y1XKHhhWQMs?autoplay=1'"></db-how-to-videos>
  </div>
</div>
